export enum CallbackType {
  OPEN = 'OPEN',
  FAIL = 'FAIL',
  CLOSE = 'CLOSE',
  RECEIVE_MSG = 'RECEIVE_MSG',
}

export interface CallbackMethod {
  (cbType: CallbackType, payload?: any): void;
}

// export enum SpeechProvider {
//   IST_PRIVATE = 'ist_private',
//   TENCENT = 'tencent',
//   LAB = 'lab',
//   GOOGLE = 'google',
//   MICROSOFT = 'microsoft_private',
// }

export enum LanguageCode {
  CHINESE = 'zh',
  ENGLISH = 'en',
  JAPANESE = 'ja',
}

export const SmartErrorCode = {
  HEART_BEAT_ERROR: 1001,
  FRONTIER_SOCKET_ERROR: 1002,

  SPEAKER_SOCKET_ERROR: 2002,
};
